<div class="maintenance-lockdown app-tone-bg-surface">
  @if (maintenanceNotice.lockdownPending()) {
    <div class="maintenance-lockdown__loading">
      <app-loading-spinner />
    </div>
  } @else if (maintenanceNotice.lockdown(); as content) {
    <header class="maintenance-lockdown__header">
      <img
        class="maintenance-lockdown__logo"
        src="/Zuehlke_Logo_withoutClaim_rgb.png"
        width="48"
        height="48"
        alt="Zühlke"
      />
      <span class="maintenance-lockdown__app-name app-type-title-md app-tone-text-secondary"
        >Momentum</span
      >
      <div class="maintenance-lockdown__user">
        <app-sidebar-user />
      </div>
    </header>

    <main class="maintenance-lockdown__main" role="main" id="main-content">
      <div class="maintenance-lockdown__panel" role="status">
        <span class="maintenance-lockdown__icon pi pi-wrench" aria-hidden="true"></span>
        <h1 class="maintenance-lockdown__title app-type-title-lg">{{ content.title }}</h1>
        <p class="maintenance-lockdown__message app-type-body">{{ content.message }}</p>
        <p class="maintenance-lockdown__schedule app-type-small app-tone-text-muted">
          <span class="maintenance-lockdown__schedule-headline">{{ content.headline }}</span>
          @for (detail of content.details; track detail) {
            <span class="maintenance-lockdown__schedule-detail">{{ detail }}</span>
          }
        </p>
        @if (content.moreInfoUrl) {
          <a
            class="maintenance-lockdown__link app-type-body-strong"
            [href]="content.moreInfoUrl"
            target="_blank"
            rel="noopener noreferrer"
            >More information</a
          >
        }
      </div>
    </main>
  }
</div>
